module.exports = __webpack_public_path__ + "img/1.bf5a086e.png";